"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrailerVideoStencil = exports.trailerVideoStencilDefinition = void 0;
const properties_1 = require("../properties");
const rbtvContentAreas = [
    {
        name: 'main',
        items: [
            'title',
            'subheading',
            'teaser',
            'description',
            'epg-description',
            'mediabase-essence',
            'video-markers',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'epg-title',
                    'uri-title',
                    'url',
                    'featured-media',
                    'social-media-image',
                    'featured-video',
                    'geolocation',
                    'extra-for',
                ],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'no-embedding',
                    'standalone',
                    'no-monetization',
                    'sponsored-by',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-persons',
            'tag-teams',
            'related-content',
        ],
    },
];
exports.trailerVideoStencilDefinition = {
    view: {
        label: 'Trailer video',
        group: 'Moving images',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'subheading',
                    'teaser',
                    'description',
                    'mediabase-essence',
                    'video-markers',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'epg-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'social-media-image',
                            'featured-video',
                            'geolocation',
                            'extra-for',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'no-embedding',
                            'standalone',
                            'no-monetization',
                            'sponsored-by',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.descriptionPropertyDefinition.name]: properties_1.descriptionPropertyDefinition,
        [properties_1.mediabaseEssencePropertyDefinition.name]: properties_1.mediabaseEssencePropertyDefinition,
        [properties_1.videoMarkersPropertyDefinition.name]: properties_1.videoMarkersPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.epgDescriptionPropertyDefinition.name]: properties_1.epgDescriptionPropertyDefinition,
        [properties_1.epgTitlePropertyDefinition.name]: properties_1.epgTitlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: {
            ...properties_1.featuredVideoPropertyDefinition,
            view: {
                label: 'Featured video',
                style: '',
                hint: 'Used to represent the content piece on collection pages.',
                hintAdditional: 'If there is a preview clip available it will be automatically embedded here after publishing. Please notice it may take a few minutes upon publishing before the preview clip will show.',
            },
        },
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.extraForPropertyDefinition.name]: properties_1.extraForPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.socialMediaImagePropertyDefinition.name]: properties_1.socialMediaImagePropertyDefinition,
        [properties_1.noMonetizationPropertyDefinition.name]: properties_1.noMonetizationPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.subheadingPropertyDefinition.name]: properties_1.subheadingPropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
        [properties_1.noEmbeddingPropertyDefinition.name]: properties_1.noEmbeddingPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.sponsoredByPropertyDefinition.name]: properties_1.sponsoredByPropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'brand-building-events',
        'media-partnerships',
        'racing-bulls',
        'rbtv',
        'rbtv_temporary',
        'redbull_com',
        'redbull-racing',
    ],
    name: 'trailer-video',
    overwrites: [
        {
            condition: 'space',
            argument: 'rbtv',
            contentAreas: rbtvContentAreas,
        },
    ],
};
const isTrailerVideoStencil = (stencil) => {
    return stencil.name === exports.trailerVideoStencilDefinition.name;
};
exports.isTrailerVideoStencil = isTrailerVideoStencil;
//# sourceMappingURL=data:application/json;base64,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